import { Box, Typography, Stack, TextField, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import SaveIcon from "@mui/icons-material/Save";
import ClearIcon from "@mui/icons-material/Clear";
import { startToast, updateToastSuccess, updateToastError } from "../../../utils/notification-loading";
import API from "../../../api";

const ChangeNameLecs = () => {
  const [lecsName, setLecsName] = useState("");

  useEffect(() => {
    API.getLecsName()
      .then((res) => {
        setLecsName(res.data.nomeLecs ?? "");
      })
      .catch((error) => {
        
      });
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "rgba(69, 144, 149, 0.05)",
        borderRadius: 2,
        border: "1px solid rgba(69, 144, 149, 0.1)",
        p: 3,
      }}
    >
      <Typography sx={{ fontSize: 18, fontWeight: 600, color: "#449095", mb: 2 }}>
        Lecs name
      </Typography>

      <CustomTextField
        variable={lecsName}
        setVariable={setLecsName}
        label={"Lecs name"}
      />
    </Box>
  );
};

export default ChangeNameLecs;

const CustomTextField = ({ variable = "", setVariable, label }) => {
  const [disabled, setDisabled] = useState(true);
  const [newValue, setNewValue] = useState("");

  useEffect(() => setNewValue(variable), [variable]);

  const handleChangeData = () => {
    startToast();
    API.setLecsName({ newName: newValue })
      .then(() => {
        updateToastSuccess("Lecs name changed successfully");
        setVariable(newValue);
        setDisabled(true);
      })
      .catch((error) => {
        
        setNewValue(variable);
        updateToastError("Error on lecs name change");
      });
  };

  const handleCancel = () => {
    setNewValue(variable);
    setDisabled(true);
  };

  const slotProps = !disabled
    ? {
        input: {
          endAdornment: (
            <IconButton onClick={handleChangeData}>
              <SaveIcon />
            </IconButton>
          ),
        },
      }
    : undefined;

  return (
    <Stack direction={"row"} spacing={2}>
      <TextField
        value={newValue}
        onChange={(e) => setNewValue(e.target.value)}
        label={label}
        disabled={disabled}
        slotProps={slotProps}
        fullWidth
      />

      {disabled ? (
        <IconButton onClick={() => setDisabled(false)}>
          <ModeEditIcon sx={{flexShrink: 0}}/>
        </IconButton>
      ) : (
        <IconButton onClick={handleCancel}>
          <ClearIcon sx={{flexShrink: 0}}/>
        </IconButton>
      )}
    </Stack>
  );
};